import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { initials } from "./profileData";

const Icon = ({ path }) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d={path}
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Icon.propTypes = { path: PropTypes.string.isRequired };

/*
 * Loyalty Points and Notifications appear in the reference but the API
 * carries neither, so the nav lists only the sections that hold real data.
 */
const LINKS = [
  { to: "/profile", end: true, label: "Dashboard", icon: "M4 13h7V4H4zM13 9h7V4h-7zM13 20h7v-9h-7zM4 20h7v-5H4z" },
  { to: "/profile/orders", label: "Order History", icon: "M5 4h11l3 3v13H5zM8 10h8M8 14h8M8 18h5" },
  { to: "/wishlist", label: "Wishlist", icon: "M12 20s-7-4.4-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.6-7 9-7 9z" },
  { to: "/profile/addresses", label: "Saved Addresses", icon: "M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" },
  { to: "/profile/payments", label: "Payment Methods", icon: "M3 8h18M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM7 15h4" },
  { to: "/profile/edit", label: "Profile Settings", icon: "M12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0" },
];

const ProfileSidebar = ({ name, email, verified, onSignOut }) => (
  <aside className="c4prf__side">
    <div className="c4prf__ident">
      <span className="c4prf__avatar" aria-hidden="true">
        {initials(name || email)}
      </span>
      <p className="c4prf__ident-name">{name || "Your account"}</p>
      {email ? <p className="c4prf__ident-mail">{email}</p> : null}
      {verified ? (
        <span className="c4prf__tag">
          <Icon path="m5 12.5 4 4 10-10" />
          Verified account
        </span>
      ) : (
        <span className="c4prf__tag c4prf__tag--wait">Email not verified</span>
      )}
    </div>

    <nav className="c4prf__nav" aria-label="Profile sections">
      {LINKS.map((link) => (
        <NavLink
          className={({ isActive }) =>
            `c4prf__nav-link${isActive ? " c4prf__nav-link--on" : ""}`
          }
          key={link.to}
          to={process.env.PUBLIC_URL + link.to}
          end={link.end}
        >
          <Icon path={link.icon} />
          {link.label}
        </NavLink>
      ))}
    </nav>

    <button className="c4prf__signout" type="button" onClick={onSignOut}>
      <Icon path="M15 17l5-5-5-5M20 12H9M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6" />
      Sign Out
    </button>
  </aside>
);

ProfileSidebar.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  verified: PropTypes.bool,
  onSignOut: PropTypes.func.isRequired,
};

export default ProfileSidebar;
